// extracted by mini-css-extract-plugin
export default {"popperContainer":"SelectCefrLevels_popperContainer__mAV3s"};